// Generated by pnpm --filter @langfuse/icons generate. Do not edit.
import { createIcon } from "../../create-icon.js";
import { LucideSparkles as RawLucideSparkles } from "lucide-react";
export const LucideSparkles = /* @__PURE__ */ createIcon(RawLucideSparkles, "LucideSparkles", 2);
